<template>
  <div class="sp-plp-page">
    <slot
      name="plp-top"
      :filterData="filterComputedData"
      :onFilter="handleFilterPlp"
      :totalCount="totalCount"
      :selectedFilterData="selectedFilterData"
      :resetFilterData="resetFilterData"
      :dataList="dataList"
    />
    <div>
      <!-- 促销标题 倒计时等 -->

      <!-- PLP Filter 区域 -->
      <slot
        name="plp-filter"
        :filterData="filterComputedData"
        :onFilter="handleFilterPlp"
        :totalCount="totalCount"
        :selectedFilterData="selectedFilterData"
        :resetFilterData="resetFilterData"
        :dataList="dataList"
      >
        <!-- !pageLoad -->
        <!-- <GtSkeleton v-if="!hiddenFilter" :rows="2" :loading="!pageLoad" class="filter">
          <GtFilter
            :hidden="hiddenFilter"
            :hidden-filter-pages="hiddenFilterOptionsPages"
            :data="filterComputedData"
            :selected-filter-data="selectedFilterData"
            :show-title="showTitle"
            :title="
              $route.name === 'plpSearch'
                ? t('sp.plp.search_results_for_product', {
                    n: totalCount
                  })
                : t('sp.plp.all_product_n', {
                    n: totalCount
                  })
            "
            @filter="handleFilterPlp"
          />
        </GtSkeleton> -->
      </slot>

      <!-- !pageLoad -->
      <GtSkeleton
        :loading="!pageLoad"
        class="gt-page-plp_skeleton_product"
        :count="isMobile ? 6 : 20"
      >
        <slot slot="template" name="skeleton-item">
          <div
            ref="skeletonProductItem"
            :style="{ width: compHeight, height: compHeight }"
            :class="{
              'skeleton-product_item': true
            }"
          >
            <GtSkeletonItem variant="image" class="plp-item" />
            <GtSkeleton :rows="3" class="plp" />
          </div>
        </slot>
        <div>
          <slot
            name="list-top"
            :filterData="filterComputedData"
            :onFilter="handleFilterPlp"
            :totalCount="totalCount"
            :selectedFilterData="selectedFilterData"
            :resetFilterData="resetFilterData"
          />

          <sp-scroll-loading
            :has-next-page="hasNextPage"
            :load-more="handleNextPage"
            :need-scroll-load="needScrollLoad"
            :distance="distance"
          >
            <div v-loading="loading" class="sp-scroll-loading">
              <no-ssr>
                <slot name="plp-list" :dataList="dataList">
                  <sp-waterfull-list
                    v-if="mode == 'waterfalls'"
                    ref="$spScrollLpadding"
                    :list="dataList"
                    :gutter="options.gutter"
                    :has-around-gutter="options.hasAroundGutter"
                    :breakpoints="computedBreakPointer"
                    :img-selector="options.imgSelector"
                    :background-color="options.backgroundColor"
                    :animation-effect="options.animationEffect"
                    :animation-duration="options.animationDuration"
                    :animation-delay="options.animationDelay"
                  >
                    <template #item="{ item, itemWidth, imgHeight, index }">
                      <!-- PLP item 区域 -->
                      <slot
                        name="plp-item"
                        :item="item"
                        :data="item"
                        :imgHeight="imgHeight"
                        :index="index"
                        :dataList="dataList"
                      >
                        <GtPlpCard
                          :key="`grid-item-${item.productCode}`"
                          class="plp-item-default"
                          :show-sale-label="showSaleLabel"
                          :data="item"
                          :img-height="`${imgHeight}px`"
                        />
                      </slot>
                    </template>
                  </sp-waterfull-list>
                  <sp-grid-list
                    v-if="mode == 'grid'"
                    ref="$spScrollLpadding"
                    :list="dataList"
                    :gutter="options.gutter"
                    :has-around-gutter="options.hasAroundGutter"
                    :breakpoints="computedBreakPointer"
                  >
                    <slot slot="banner-left_top" name="banner-left_top" />
                    <template #item="{ item, imgHeight, index }">
                      <!-- PLP item 区域 -->
                      <slot
                        name="plp-item"
                        :item="item"
                        :data="item"
                        :imgHeight="imgHeight"
                        :dataList="dataList"
                        :index="index"
                      >
                        >
                        <GtPlpCard
                          :key="`grid-item-${item.productCode}`"
                          class="plp-item-default"
                          :show-sale-label="showSaleLabel"
                          :data="item"
                          :img-height="`${imgHeight}px`"
                        />
                      </slot>
                    </template>
                  </sp-grid-list>
                </slot>
              </no-ssr>
              <!-- 分页器 -->
              <div v-if="needPaginator" class="sp-plp-page__pgin">
                <sp-paginator
                  :current-page="curPage"
                  :type="paginatorType"
                  :total="totalCount"
                  @handleSetPageInput="handleSetPageInput"
                />
              </div>

              <!-- 更多 -->
              <div v-if="!hiddenEnd && dataList.length != 0" class="sp-plp-page__morebtn">
                <sp-button v-if="showMoreBtn" @click="handleNextPage">
                  {{ showMoreText }}
                </sp-button>
                <p v-if="!hasNextPage && dataList.length != 0 && pageLoad" class="no-more-text">
                  {{ t('sp.common.end') }}
                </p>
              </div>
              <div v-if="nextPageLoading">
                <slot name="nextPageLoading" />
              </div>
            </div>
          </sp-scroll-loading>
        </div>
      </GtSkeleton>

      <template v-if="dataList.length == 0 && !loading && pageLoad">
        <slot name="empty">
          <GtEmpty :text="emptyText" />
        </slot>
      </template>
    </div>
  </div>
</template>

<script>
import {
  componentsCommon,
  GtButton,
  GtPlpCard,
  GtScrollLoading,
  GtWaterfullList,
  GtGridList,
  // GtFilter,
  GtSkeleton,
  GtSkeletonItem,
  GtEmpty
} from '@speedshop/template';
import { useCatalogProduct } from '@speedshop/sdk-api';
import GtPaginator from './paginator.vue';

export default {
  name: 'Plp',
  components: {
    'sp-paginator': GtPaginator,
    'sp-scroll-loading': GtScrollLoading,
    'sp-button': GtButton,
    'sp-waterfull-list': GtWaterfullList,
    'sp-grid-list': GtGridList,
    // GtFilter,
    GtSkeleton,
    GtSkeletonItem,
    GtEmpty,
    GtPlpCard
  },
  mixins: [componentsCommon],
  props: {
    // mode 模式 waterfalls ==》 瀑布流计算位置模式   grid ==》 css模式
    mode: {
      type: String,
      default: 'grid'
    },
    categoryCode: {
      type: String
    },
    // 商品组件是否优先 wcm 配置的 columns
    priorityWcmColumn: {
      type: Boolean,
      default: false
    },
    // 商品组件 wcm 配置的 columns
    wcmColumns: {
      type: [String, Number],
      default: 4
    },
    // 其他一些请求参数
    params: {
      type: Object,
      default: () => ({})
    },
    // 是否请求下一页
    hasNext: {
      type: Boolean,
      default: true
    },
    // promotion 页面过来的（最多几行 即最多几个数据）
    maxProductCount: {
      type: Number,
      default: 1000
    },
    // 首页实例数据
    previewData: {
      type: Object,
      default: () => ({})
    },
    showMoreText: {
      type: String,
      default: 'Show more'
    },
    // PC是否需要滚动加载
    needScrollLoad: {
      type: Boolean,
      default: true
    },
    // 移动端是否需要滚动加载
    h5NeedScrollLoad: {
      type: Boolean,
      default: true
    },
    // 是否需要分页器
    needPaginator: {
      type: Boolean,
      default: false
    },
    // 分页器类型
    paginatorType: {
      type: Number,
      default: 1
    },
    // 筛选器左边文案是否展示
    showTitle: {
      type: Boolean,
      default: true
    },
    // 隐藏筛选器的页面（path 或者 name）
    hiddenFilterOptionsPages: {
      type: Array,
      default: () => ['plpSearch', '/page/flash-sale', '/page/pre-order', 'home']
    },
    // 筛选器选中的数据
    selectedFilterData: {
      type: [Array, Object],
      default: () => ({})
    },
    // 是否不展示整个筛选块
    hiddenFilter: {
      type: Boolean,
      default: false
    },
    // 隐藏 End
    hiddenEnd: {
      type: Boolean,
      default: false
    },
    // 瀑布流props options
    waterFallOptions: {
      type: Object,
      default: () => {
        return {
          // 卡片之间的间隙
          gutter: 25,
          // 是否有周围的gutter
          hasAroundGutter: false,
          // 自定义行显示个数，主要用于对移动端的适配
          breakpoints: {
            1980: {
              //当屏幕宽度小于等于1200
              rowPerView: 5
            },
            1318: {
              //当屏幕宽度小于等于1200
              rowPerView: 3
            },
            800: {
              //当屏幕宽度小于等于800
              rowPerView: 2
            },
            500: {
              //当屏幕宽度小于等于500
              rowPerView: 2
            }
          },
          // 动画效果
          animationEffect: 'fadeInUp',
          // 动画时间
          animationDuration: 1000,
          // 动画延迟
          animationDelay: 100,
          // imgSelector
          imgSelector: 'mobileMediaLink'
        };
      }
    },
    // 展示 SALE label 的页面
    showSalesLabelsPages: {
      type: Array,
      default: () => ['/page/flash-sale']
    },
    useCatalogProduct: {},
    distance: {
      type: [Function, Number],
      default: () => {
        return 100;
      }
    },
    afterLoadMore: {
      type: Function
    },
    scrollEl: {}
    //TODO: top 部分是否需要贴顶
    //TODO: sp-scroll-loading 的高度是否固定在某元素
  },
  data() {
    return {
      // 搜索关键字
      conditionKeyword: (this.previewData && this.previewData.conditionKeyword) || '',
      // 是否是路由改变标志，搜索进入的需要重置所有
      rerender: false,
      // 页面是否已经加载完
      pageLoad: false,
      loading: false,
      totalCount: 0,
      currentPage: 1,
      dataList: (this.previewData && this.previewData.productList) || [],
      hasNextPage: true,
      plp: null,
      // plp card 图片的高度，高度设为固定为不同列表，设置为auto为瀑布流
      cardImgHeight: '246px',
      // 所有过滤条件（用于过滤器渲染）
      filterComputedData: (this.previewData && this.previewData.filterData) || [],
      // 选中的过滤器数据
      filterAttrs: {},
      categoryCodeList: [],
      brandCodeList: [],
      priceFilter: [],
      fqList: [],
      sortList: [
        // { name: 'salePrice', sort: 1 },
        // { name: 'sort', sort: 1 }
      ],
      // 临时attrList
      tempAttrList: [],
      tempSpuAttrList: [],
      attrList: [],
      numberFilter: 'salePrice',
      timer: null,
      spuAttrList: [],
      tagCodeList: [],
      nextPageLoading: false
    };
  },
  computed: {
    emptyText() {
      return this.dataList.length == 0 && this.$route.name == 'plpSearch'
        ? this.t('sp.plp.no_results_were_found')
        : this.$route.name !== 'plpSearch' && this.dataList.length == 0
        ? this.t('sp.common.no_data')
        : '';
    },
    // 是否展示列表底部的展示更多按钮
    showMoreBtn() {
      if (!this.isMobile) {
        return this.hasNextPage && !this.needScrollLoad && this.dataList.length > 0;
      } else {
        return this.hasNextPage && !this.h5NeedScrollLoad && this.dataList.length > 0;
      }
    },
    curPage() {
      return Math.ceil(this.dataList.length / this.pageSize);
    },
    // 是否展示促销标签
    showSaleLabel() {
      return this.showSalesLabelsPages.includes(this.$route.path);
    },
    // 是否优先取WCM配置的列还是屏幕自适应
    computedBreakPointer() {
      return this.priorityWcmColumn
        ? {
            1980: {
              rowPerView: this.wcmColumns
            }
          }
        : this.options.breakpoints;
    },

    compHeight() {
      return this.priorityWcmColumn ? `calc(100%/${this.wcmColumns} - 8px)` : this.cardImgHeight;
    },
    options() {
      const {
        // 卡片之间的间隙
        gutter = this.isMobile ? 14 : 26,
        // 是否有周围的gutter
        hasAroundGutter = false,
        // 自定义行显示个数，主要用于对移动端的适配
        breakpoints = {
          1980: {
            //当屏幕宽度小于等于1200
            rowPerView: 5
          },
          1318: {
            //当屏幕宽度小于等于1200
            rowPerView: 3
          },
          800: {
            //当屏幕宽度小于等于800
            rowPerView: 2
          },
          500: {
            //当屏幕宽度小于等于500
            rowPerView: 2
          }
        },
        // 动画效果
        animationEffect = 'fadeInUp',
        // 动画时间
        animationDuration = 1000,
        // 动画延迟
        animationDelay = 100,
        // imgSelector
        imgSelector = 'mobileMediaLink'
      } = this.waterFallOptions;
      return {
        gutter,

        hasAroundGutter,

        breakpoints,

        animationEffect,

        animationDuration,

        animationDelay,
        imgSelector
      };
    }
  },

  watch: {
    isMobile: {
      deep: true,
      handler() {
        console.log('isMobile change');
        this.setDeviceChange();
      }
    },
    previewData(val) {
      console.log('previewData change', 1);
      this.init();
    }
  },

  async mounted() {
    // if (this.categoryCode !== this.$route.params.category || !this.previewData)
    //   return
    //   console.log('mounted init',2)
    await this.init();
    this.$nextTick(() => {
      this.$refs?.$spScrollLpadding?.init();
    });
  },

  methods: {
    // 设备改变的时候一些设置项的重置
    setDeviceChange() {
      if (this.isMobile) {
        this.cardImgHeight = 'auto';
        this.options.hasAroundGutter = false;
      } else {
        this.cardImgHeight = this.priorityWcmColumn
          ? `calc(100%/${this.wcmColumns})`
          : this.cardImgHeight;
        this.options.hasAroundGutter = !this.priorityWcmColumn;
      }
    },

    async init() {
      this.loading = true;
      this.setDeviceChange();
      // 此处判断不合理，需要优化
      if (this.previewData?.filterData || this.previewData?.productList?.length) {
        console.log('init previewData', 1, this.previewData);
        this.filterComputedData = (this.previewData && this.previewData.filterData) || [];
        this.setData({
          dataList: this.previewData.productList,
          ...this.previewData
        });
        // 初始化
        const plp = this.useCatalogProduct ? this.useCatalogProduct() : useCatalogProduct();
        this.plp = plp;

        await plp.init({
          ...this.params,
          prefetch: false,
          ...this.previewData
        });
        this.pageLoad = true;
        this.loading = false;
      } else {
        // console.log('init previewData', 2)
        // //初始化
        // const plp = this.useCatalogProduct
        //   ? this.useCatalogProduct()
        //   : useCatalogProduct()
        // this.plp = plp
        // let res = await plp.init({
        //   ...this.params,
        //   prefetch: true
        // })
        // this.setData({
        //   ...res
        // })
        // console.log('init previewData3', plp)
        // this.filterComputedData = this.plp.filterData || []
        // setTimeout(v => {
        //   this.pageLoad = true
        //   this.loading = false
        // }, 100)
      }
    },

    async handleFilterPlp(data, types) {
      console.log(data, types, 789);
      let dataList = [];
      if (types) {
        dataList = [{ data, types }];
      } else {
        dataList = data;
      }
      dataList.forEach(({ data, types }) => {
        let { code: type = '', attrCate } = types;
        console.log(attrCate, 123);
        this.filterAttrs[type] = data;
        // 分类数据
        if (type == 'CATEGORY') {
          this.categoryCodeList =
            data.length > 0
              ? data.map(v => {
                  if (v.code) {
                    return v.code;
                  }
                })
              : [];
        }

        // Price 筛选
        if (type == 'PRICE') {
          this.$nextTick(v => {
            if (!(data && Number.isNaN(data[0]))) {
              if (this.fqList && this.fqList.length > 0) {
                this.fqList.forEach((v, i) => {
                  if (v.key == 'salePrice') {
                    this.$set(this.fqList[i], 'value', data ? data.toString() : []);
                  }
                });
              } else {
                let tempArr = data
                  ? [
                      {
                        fq: 'ra',
                        key: 'salePrice',
                        value: data.toString()
                      }
                    ]
                  : undefined;
                this.$set(this, 'fqList', tempArr);
              }
              this.$set(this, 'fqList', this.fqList);
            }
          });
        }

        // STOCK 筛选
        if (type == 'STOCK') {
          if (this.fqList.length > 0) {
            this.fqList = this.fqList.filter(v => {
              return v.key != 'sort';
            });

            if (data.length === 1) {
              data.map(v => {
                let fq = v.value > 0 ? 'gte' : 'lt';
                this.fqList.push({
                  fq,
                  key: 'sort',
                  value: 0
                });
              });
            }
          } else {
            data.map(v => {
              let fq = v.value > 0 ? 'gte' : 'lt';
              this.fqList.push({
                fq,
                key: 'sort',
                value: 0
              });
            });
          }

          let stockArr =
            this.fqList.filter(v => {
              return v.key === 'sort';
            }) || [];
          // 如果都选中了代表所有，则不留库存查询
          if (stockArr && stockArr.length == 2) {
            this.fqList = this.fqList.filter(v => v.key !== 'sort');
          }
        }

        // BRAND 筛选
        if (type == 'BRAND') {
          let brandList =
            data.length > 0
              ? data.map(v => {
                  if (v.code) {
                    return v.code;
                  }
                })
              : [];
          this.brandCodeList = [...brandList];
        }

        // 排序筛选
        if (type == 'SORT') {
          if (Array.isArray(data)) {
            this.sortList = data.map(i => i.value);
          } else {
            if (data && data.value) {
              this.$set(this, 'sortList', [data.value]);
            }
          }
        }
        // SKU 筛选
        if (attrCate == 'SKUATTR') {
          if (data && data.length > 0) {
            data.forEach((v, i) => {
              if (i === data.length - 1) {
                this.tempAttrList.push({
                  attrType: v.attrType, // sku attr
                  attrCode: v.parentCode,
                  attrValue: data.map(v => v.valueCode)
                });
              }
            });
          }
          let newAttrList = this.handlerDatas(this.tempAttrList, type, data);
          let finalList = [...newAttrList];

          this.attrList = finalList;
        }

        // SPU attr 筛选
        if (attrCate == 'SPUATTR') {
          if (data && data.length > 0) {
            console.log(data, 'attrCate SPUATTR');
            data.forEach((v, i) => {
              if (i === data.length - 1) {
                this.tempSpuAttrList.push({
                  attrType: v.attrType, // sku attr
                  attrCode: v.parentCode,
                  attrValue: data.map(v => v.valueCode)
                });
              }
            });
          }

          let newAttrList = this.handlerDatas(this.tempSpuAttrList, type, data);
          let finalList = [...newAttrList];
          console.log(finalList, 'finalList');

          this.spuAttrList = finalList;
        }

        // BRAND 筛选
        if (type == 'TAG') {
          console.log('TAG', 'TAGssss');
          let list =
            data.length > 0
              ? data.map(v => {
                  if (v.tagCode) {
                    return v.tagCode;
                  }
                })
              : [];
          this.tagCodeList = [...list];
        }
      });

      await this.handleSelectFilterCondition();
    },

    async handleNextPage() {
      console.log('下一页');
      if (this.hasNextPage && this.hasNext && !this.nextPageLoading) {
        try {
          this.nextPageLoading = true;
          let data = {};
          //点击下一页
          data = await this.plp?.nextPage();
          this.setData(data);
          this.$nextTick(async () => {
            this.afterLoadMore && (await this.afterLoadMore());

            setTimeout(() => {
              this.nextPageLoading = false;
            }, 1000);
          });
        } catch (e) {
          console.log(e);
          this.nextPageLoading = false;
        }
      }
    },

    async handleSelectFilterCondition() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
        this.loading = false;
      }
      this.loading = true;
      this.timer = setTimeout(async () => {
        this.$nextTick(async () => {
          let sendData = {
            categoryCode: this.categoryCode,
            numberFilter: this.numberFilter,
            conditionKeyword: this.conditionKeyword || '',
            categoryCodeList: this.categoryCodeList || [],
            brandCodeList: this.brandCodeList || [],
            fqList: this.fqList,
            attrList: this.attrList || [],
            sortList: this.sortList,
            spuAttrList: this.spuAttrList || [],
            tagCodeList: this.tagCodeList || []
          };
          this.$set(sendData, 'fqList', this.fqList);

          //初始化
          let res = {};

          if (this.plp) {
            res = await this.plp?.checkCondition(sendData).finally(() => {
              this.loading = false;
              this.timer = null;
              this.tempAttrList = [];
              this.tempSpuAttrList = [];
            });
          } else {
            const plp = this.useCatalogProduct ? this.useCatalogProduct() : useCatalogProduct();
            this.plp = plp;
            res = await this.plp?.checkCondition(sendData).finally(() => {
              this.loading = false;
              this.timer = null;
              this.tempAttrList = [];
              this.tempSpuAttrList = [];
            });
          }
          this.setData(res);
        });
      }, 400);
    },

    async handleRefresh() {
      const data = await this.plp.refresh();
      this.setData(data);
    },

    handleSetPageInput(pageNum) {
      this.plp.setPageInput(pageNum);
    },

    setData(data) {
      const { dataList = [], hasNextPage, pageInfo, pageNum } = data;
      let partOfDataList = [...dataList].splice(0, this.maxProductCount);
      this.dataList = this.hasNext ? dataList : partOfDataList;
      this.hasNextPage = (pageInfo && pageInfo.hasNextPage) || false;
      this.totalCount = (pageInfo && pageInfo.totalCount) || 0;
      this.currentPage = pageNum;
    },

    handlerDatas(arr, type, data) {
      // console.log('template lsit==>', arr)
      // console.log('template type===>', type)
      // console.log('template data====>', data)
      let obj = {};
      if (arr.length > 0) {
        arr.forEach((item, index) => {
          let { attrType, attrCode, attrValue } = item;
          if (!obj[attrType] && !obj[attrCode]) {
            obj[attrCode] = {
              attrCode,
              attrType,
              attrValue
            };
          }
          obj[attrCode].attrValue = attrValue;
        });
        let data = Object.values(obj);
        return data;
      } else {
        return [];
      }
    },
    async resetFilterData() {
      this.filterAttrs = {};
      this.brandCodeList = [];
      this.priceFilter = [];
      this.fqList = [];
      this.tempAttrList = [];
      this.tempSpuAttrList = [];
      this.attrList = [];
      this.spuAttrList = [];
      this.tagCodeList = [];
      this.categoryCodeList = [];
      await this.handleSelectFilterCondition();
    }
  }
};
</script>

<style lang="scss" >
#nuxt-app {
  overflow-y: auto;
}
.sp-plp-page {
  height: auto;
  min-height: 80vh;
  width: 100%;
  background-color: #fff;
  padding: 0;
  .gt-skeleton {
    margin: 20px auto 20px;
    width: 100%;
    max-width: var(--page-max-width);
    .gt-skeleton-item {
      width: 100%;
      height: 250px;
      margin-bottom: 20px;
      &.el-skeleton__p {
        height: 20px;
      }
    }
    .el-skeleton__image {
    }
  }
  .gt-page-plp_skeleton_product {
    width: 100%;
    max-width: var(--page-max-width);
    margin: 0px auto;

    .el-skeleton {
      display: flex;
      flex-wrap: wrap;
      .skeleton-product_item {
        width: 20%;
        padding: 20px;
        background: #fff;
      }
    }
  }
  .sp-plp-top {
    // border-bottom: var(--border-small-default);
    position: sticky;
    position: -webkit-sticky;
    background: #fff;
    z-index: 1;
    top: var(--header-pc-height);
  }

  &__morebtn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 12px;
    margin-top: 12px;
    border-top: var(--plp-no-more-text-border-top);

    .no-more-text {
      color: var(--plp-no-more-text-color);
      padding: var(--plp-no-more-text-padding);
    }
  }
  &__pgin {
    margin-top: 12px;
  }
  .sp-scroll-loading {
    max-width: var(--page-max-width);
    height: auto;
    overflow-y: auto;
    margin: 0 auto;
  }
  .el-loading-mask {
    z-index: 9999;
  }
}
</style>
<style lang="scss" >
.page-layout_pc {
  .sp-scroll-loading {
    max-width: var(--page-max-width);
  }
}
</style>

<style lang="scss">
@media only screen and (max-width: 1200px) {
  .sp-plp-page {
    padding: 0 40px;
    .gt-page-plp_skeleton_product {
      .el-skeleton {
        .el-skeleton__image {
          min-height: 120px;
        }
        .skeleton-product_item {
          width: 33%;
          padding: 20px;
          background: #fff;
        }
        .el-skeleton__p {
          height: 20px;
        }
      }
    }
  }
}
</style>
<style lang="scss" >
.page-layout_mobile {
  .sp-plp-page {
    height: auto;
    padding: 0 16px;

    .gt-page-plp_skeleton_product {
      width: 100%;
    }
    .gt-skeleton {
      width: 100%;
      margin: 0px auto 16px;
      &.filter {
        height: 50px;
      }
      .el-skeleton {
        .skeleton-product_item {
          width: 50%;
          min-width: 140px;
          height: 122px;
          margin-bottom: 10px;
          .el-skeleton__item {
            height: auto;
          }
          .el-skeleton__p {
            width: 100%;
            height: 20px;
            margin-bottom: 10px;
          }
        }
      }
    }

    .sp-plp-top {
      top: var(--header-mobile-height);
    }
    .el-loading-mask {
      z-index: 1999;
    }
  }
}
</style>
